import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthService } from '@klickdata/core/auth';
import { SideNaveActionsTypes, SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { ResourceOpportunity } from '@klickdata/core/opportunity';
import { User } from '@klickdata/core/user';
import { OccasionService } from '@klickdata/player/src/core/occasion/occasion.service';
import { CourseItemsActionsOnNext, TakeResActionValue } from '@klickdata/player/src/next-step.service';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { filter, first, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'app-menu-side-course-material-item-done',
    templateUrl: './menu-side-course-material-item-done.component.html',
    styleUrls: ['./menu-side-course-material-item-done.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideCourseMaterialItemDoneComponent extends OnDestroyHandler {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    SideNaveActionsTypes = SideNaveActionsTypes;
    public feedback = new FormControl();
    public showInput = false;
    public doneBtnClicked = false;
    public showGroupWork = false;
    public showGroups = false;
    public auDoneMaterial = false;
    public participantUsers: User[] = [];
    TakeResActionValue = TakeResActionValue;
    public canDonWithGroup: boolean;
    public authUser: User;
    public hideMain = false;
    public hideGroupWork = false;
    public hideDoneGroupWork = false;
    public timeSpendControl: FormControl = new FormControl();

    constructor(
        protected cdr: ChangeDetectorRef,
        protected occasionService: OccasionService,
        protected auth: AuthService
    ) {
        super();
        this.auth
            .getUser()
            .pipe(takeUntil(this.destroy))
            .subscribe((user) => {
                this.authUser = user;
                this.canDonWithGroup = user.canPlayAsGroupLeader();
            });
    }
    onClickAction(action: CourseItemsActionsOnNext) {
        if (this.navData.data.showCustomBtnAfterClickDone && action.value == TakeResActionValue.CONTINUE) {
            this.doneBtnClicked = true;
            this.cdr.markForCheck();
        } else {
            this.onClose.emit(
                action.value
                    ? {
                          data: { type: this.navData.data.type, response: action.value, feedback: this.feedback.value },
                      }
                    : null
            );
        }
    }
    public get canGoToNextMandatory(): boolean {
        return this.navData.data?.actions?.find((action) => action.value == TakeResActionValue.GO_TO_NEXT_MANDATORY);
    }
    public onDone() {
        this.doneBtnClicked = true;
        if (this.canDonWithGroup) {
            this.showGroupWork = true;
        } else {
            this.auDoneMaterial = true;
        }
        this.cdr.markForCheck();
    }
    public submit() {
        this.navData.data.childOccasion$
            .pipe(
                takeUntil(this.destroy),
                filter((res) => !!res),
                switchMap((res: ResourceOpportunity) =>
                    this.occasionService.doneGroupWork(
                        res.id,
                        this.participantUsers.map((user) => user.id).filter((id) => id != this.authUser.id),
                        true,
                        this.showGroups && this.timeSpendControl.value ? this.timeSpendControl.value : undefined
                    )
                )
            )
            .subscribe(() => {
                this.auDoneMaterial = true;
                this.cdr.markForCheck();
            });
    }
}
